module.exports = __webpack_public_path__ + "img/manageChange.9ce2b00f.png";